var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamCommunication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_7_57205)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_57205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_57205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 23V21.6875C8 21.0764 8.30556 20.5867 8.91667 20.2183C9.52778 19.8506 10.3333 19.6667 11.3333 19.6667C11.5139 19.6667 11.6842 19.6736 11.8442 19.6875C12.0036 19.7014 12.1597 19.7222 12.3125 19.75C12.1181 20.0278 11.9756 20.3264 11.885 20.6458C11.795 20.9653 11.75 21.3056 11.75 21.6667V23H8ZM13 23V21.6667C13 20.7639 13.4619 20.0311 14.3858 19.4683C15.3092 18.9061 16.5139 18.625 18 18.625C19.5 18.625 20.7083 18.9061 21.625 19.4683C22.5417 20.0311 23 20.7639 23 21.6667V23H13ZM24.25 23V21.6667C24.25 21.3056 24.2014 20.9653 24.1042 20.6458C24.0069 20.3264 23.8681 20.0278 23.6875 19.75C23.8403 19.7222 23.9967 19.7014 24.1567 19.6875C24.3161 19.6736 24.4861 19.6667 24.6667 19.6667C25.6667 19.6667 26.4722 19.8506 27.0833 20.2183C27.6944 20.5867 28 21.0764 28 21.6875V23H24.25ZM11.3333 18.8333C10.875 18.8333 10.4828 18.67 10.1567 18.3433C9.83 18.0172 9.66667 17.625 9.66667 17.1667C9.66667 16.7083 9.83 16.3158 10.1567 15.9892C10.4828 15.6631 10.875 15.5 11.3333 15.5C11.7917 15.5 12.1839 15.6631 12.51 15.9892C12.8367 16.3158 13 16.7083 13 17.1667C13 17.625 12.8367 18.0172 12.51 18.3433C12.1839 18.67 11.7917 18.8333 11.3333 18.8333ZM24.6667 18.8333C24.2083 18.8333 23.8158 18.67 23.4892 18.3433C23.1631 18.0172 23 17.625 23 17.1667C23 16.7083 23.1631 16.3158 23.4892 15.9892C23.8158 15.6631 24.2083 15.5 24.6667 15.5C25.125 15.5 25.5175 15.6631 25.8442 15.9892C26.1703 16.3158 26.3333 16.7083 26.3333 17.1667C26.3333 17.625 26.1703 18.0172 25.8442 18.3433C25.5175 18.67 25.125 18.8333 24.6667 18.8333ZM18 18C17.3056 18 16.7153 17.7569 16.2292 17.2708C15.7431 16.7847 15.5 16.1944 15.5 15.5C15.5 14.8056 15.7431 14.2153 16.2292 13.7292C16.7153 13.2431 17.3056 13 18 13C18.6944 13 19.2847 13.2431 19.7708 13.7292C20.2569 14.2153 20.5 14.8056 20.5 15.5C20.5 16.1944 20.2569 16.7847 19.7708 17.2708C19.2847 17.7569 18.6944 18 18 18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_57205",
    x1: 28.5,
    y1: 48,
    x2: 12,
    y2: -4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E57C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#9575CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#B39DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C4E9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCommunication);
export default __webpack_public_path__ + "static/media/teamCommunication.5cf681fc3d03ecc8fecf5b915184de84.svg";
export { ForwardRef as ReactComponent };